import { Immutable } from "immer";
import React from "react";
import { HomepageHeroPromoBox } from "tsi-common-react/src/components/HomepageHeroPromoBox/index";
import { OverlayBannerBlock } from "tsi-common-react/src/components/OverlayBannerBlock/index";
import { ProductCalloutBlock } from "tsi-common-react/src/components/ProductCalloutBlock/index";
import { RawHTMLBlock } from "tsi-common-react/src/components/RawHTMLBlock/index";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

export const HomeContentAssembly = (
    props: Immutable<{ page: templates.HomePageTemplate["page"] }>,
): React.JSX.Element | null => {
    if (!props.page.content) {
        return null;
    }
    return (
        <div className="l-full-width">
            <StreamField
                tagName={React.Fragment}
                value={props.page.content.value}
                components={{
                    html: RawHTMLBlock,
                    promo_box: HomepageHeroPromoBox,
                    product_callout_block: ProductCalloutBlock,
                    overlay_banner: OverlayBannerBlock,
                }}
            />
        </div>
    );
};
